import React from "react"
import { documentToReactComponents } from "@contentful/rich-text-react-renderer"

import "./general-description-legal.scss"

const GeneralDescriptionLegal = ({ mainDescription, slug, productos, continuacionDescripcion }) => {
  return (
    <div className="f-legal-description-container">
      <div className="f-position-container">
        {documentToReactComponents(mainDescription && mainDescription.json)}
        {slug === 'bajamosdeprecio/' &&
        <div className="f-position-container-hscroll">
          <table  className="f-position-container-table" border={1}>
            <tbody>
              <tr className="f-position-container-table-column">
                <th>Producto</th>
                <th >Precio de venta al <br />público sugerido <br />Anterior</th>
                <th >Precio de venta al <br /> público sugerido <br />Ahora</th>
              </tr>
                {productos && productos.map(value =>
                  <tr className="f-position-container-table-column">
                    <td>{value.producto}</td>
                    <td>{value.pAnterior}</td>
                    <td>{value.pAhora}</td>
                  </tr>
                )}
            </tbody>
          </table>
        </div>
        }
        {documentToReactComponents(continuacionDescripcion && continuacionDescripcion.json)}
      </div>
    </div>
  )
}

export default GeneralDescriptionLegal
